"use client"

import { useState, useCallback } from "react"
import { useAuth } from "../context/AuthContext"
import type { PasswordData, ChangePasswordRequest, ChangePasswordResponse } from "../types/account-details"
import { ACCOUNT_CONSTANTS } from "../constants/account-details"

export const usePasswordApi = () => {
  const { changePassword } = useAuth()

  const [isChangingPassword, setIsChangingPassword] = useState(false)

  // Transform frontend password data to API format
  const transformPasswordToApi = useCallback((passwordData: PasswordData): ChangePasswordRequest => {
    return {
      current_password: passwordData.oldPassword,
      new_password: passwordData.newPassword,
      confirm_password: passwordData.confirmPassword,
    }
  }, [])

  // Change password via API
  const changePasswordApi = useCallback(
    async (passwordData: PasswordData): Promise<boolean> => {
      setIsChangingPassword(true)

      try {
        console.log("Changing password...")

        const apiPayload = transformPasswordToApi(passwordData)
        console.log("Password change API payload prepared")

        const response: ChangePasswordResponse = await changePassword(apiPayload)

        if (response.status === 200) {
          console.log("Password changed successfully")
          return true
        } else {
          throw new Error(response.message || "Failed to change password")
        }
      } catch (error: any) {
        console.error("Error changing password:", error)
        throw new Error(error.userMessage || error.message || ACCOUNT_CONSTANTS.ERROR_MESSAGES.PASSWORD_CHANGE_FAILED)
      } finally {
        setIsChangingPassword(false)
      }
    },
    [changePassword, transformPasswordToApi],
  )

  return {
    isChangingPassword,
    changePasswordApi,
  }
}
